const common = {
  siteName: "开云平台",
  siteSlogan: "安全可信赖的首选平台",
  nav: {
    home: "首页",
    categories: "分类",
    articles: "文章",
    about: "关于我们",
  },
  footer: {
    copyright: "© 2026 开云平台 版权所有",
    privacy: "隐私政策",
    terms: "服务条款",
    sitemap: "网站地图",
    description: "开云平台致力于为用户提供安全、稳定、便捷的平台服务体验。7×24小时全天候客服支持，让您的每一次使用都安心无忧。",
    quickLinks: "快速链接",
    contactUs: "联系我们",
    hotline: "客服热线",
    email: "客服邮箱",
    address: "公司地址",
    addressValue: "北京市朝阳区建国路88号",
    followUs: "关注我们",
  },
  breadcrumb: {
    home: "首页",
    categories: "分类",
    articles: "文章",
    about: "关于我们",
  },
  button: {
    readMore: "阅读更多",
    viewAll: "查看全部",
    submit: "提交",
    contactUs: "联系我们",
    backToList: "返回列表",
    learnMore: "了解更多",
  },
  loading: "加载中...",
  error: "加载失败",
  retry: "重试",
};

export default common;